import { render, staticRenderFns } from "./addMotherPackageType.vue?vue&type=template&id=7a234afc&"
import script from "./addMotherPackageType.vue?vue&type=script&lang=js&"
export * from "./addMotherPackageType.vue?vue&type=script&lang=js&"
import style0 from "./addMotherPackageType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a234afc')) {
      api.createRecord('7a234afc', component.options)
    } else {
      api.reload('7a234afc', component.options)
    }
    module.hot.accept("./addMotherPackageType.vue?vue&type=template&id=7a234afc&", function () {
      api.rerender('7a234afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/addMotherPackageType.vue"
export default component.exports